import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppConstant } from 'src/app/_Core/_Constants/app.constant';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService implements CanActivate {

  constructor(
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!localStorage.getItem('redirectUrl')) {
      localStorage.setItem('redirectUrl', state.url);
    }
    const token = localStorage.getItem(AppConstant.localStorage.token);
    if (!token || token === '' || token === 'token') {
      this.router.navigateByUrl('');
      return false;
    }
    return true;
  }
}
